export const getRootScope = (_this_, keyProperty) => {
	let rootScopeRef,
		tempScope = null,
		found = keyProperty in _this_;

	if (!found) {
		tempScope = _this_.$parent;
	} else {
		tempScope = _this_;
	}

	while (!found) {
		if (keyProperty in tempScope) {
			found = true;
			rootScopeRef = tempScope;
		} else {
			rootScopeRef = tempScope.$parent;
		}
	}

	if (!!!rootScopeRef && !!tempScope) {
		rootScopeRef = tempScope;
	}

	return rootScopeRef;
};
